/** Meta token API error codes from backend helpers/metaTokenErrors.js */
export const META_ERROR_CODES = {
  META_NOT_CONNECTED: "META_NOT_CONNECTED",
  META_TOKEN_EXPIRED: "META_TOKEN_EXPIRED",
  META_TOKEN_REFRESH_FAILED: "META_TOKEN_REFRESH_FAILED",
  META_TOKEN_VALIDATION_FAILED: "META_TOKEN_VALIDATION_FAILED",
};

export const isMetaTokenErrorCode = (code) =>
  Boolean(code && Object.values(META_ERROR_CODES).includes(code));

export const getMetaErrorCodeFromAxiosError = (error) =>
  error?.response?.data?.code ||
  error?.response?.data?.metaTokenError?.code ||
  null;
